import { createAsyncThunk } from "@reduxjs/toolkit"
import { get, post, put, del } from "helpers/api_helper"

export const getAllGiftCardCategories = createAsyncThunk(
  "giftCardCategories/getAll",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await post("/admin/card-type/all", payload)
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const getGiftCardCategoryDetails = createAsyncThunk(
  "giftCardCategories/getDetails",
  async (cardType, { rejectWithValue }) => {
    try {
      const response = await post("/admin/card-type/get-details", { cardType })
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const addGiftCardCategory = createAsyncThunk(
  "giftCardCategories/add",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await post("/admin/card-type/add", payload)
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateGiftCardCategory = createAsyncThunk(
  "giftCardCategories/update",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await put("/admin/card-type/update", payload)
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deleteGiftCardCategory = createAsyncThunk(
  "giftCardCategories/delete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await del("/admin/card-type/delete", payload)
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const getAllGiftCardCategoriesWithoutPagination = createAsyncThunk(
  "giftCardCategories/getAllWithoutPagination",
  async () => {
    const response = await get("/admin/card-type/get-all-without-pagination")
    return response
  }
)
